import _ from 'lodash';
import { createSelector } from 'reselect';
import { IAppState } from '../../../state/reducers';
import {
  IPublishSettings,
  SettingState,
} from '../../../api/vault/publishEndpoints';

const publishSettingsSelector = (state: IAppState) => state.publishSettings.loadState.responseState;

export const selectActivePublishSettings = createSelector(
  publishSettingsSelector,
  (publishSettings) => (_.isNil(publishSettings)
    ? null
    : publishSettings.filter((s) => s.state === SettingState.Active)),
);
